// Podtemat 6 - zadania otwarte egzaminu osmoklasisty z dzialu II (algebra).

import * as PostersWordProblem from "../../temat2_rownania/E8PostersWordProblemOpenTask";
import * as OrigamiSheets from "../../temat2_rownania/E8OrigamiSheetsOpenTask";
import * as RouteTimeProof from "../../temat2_rownania/E8RouteTimeProofOpenTask";

export const registry = {
  E8PostersWordProblemOpenTask: PostersWordProblem,
  E8OrigamiSheetsOpenTask: OrigamiSheets,
  E8RouteTimeProofOpenTask: RouteTimeProof,
};

export function generateTasks(options = {}) {
  return [OrigamiSheets.generateTask(options), RouteTimeProof.generateTask(options), PostersWordProblem.generateTask(options)];
}

function moduleFor(task) {
  const mod = registry[task.type];
  if (!mod) throw new Error(`Unknown E8 open task type: ${task.type}`);
  return mod;
}

export function renderTask(task) {
  return moduleFor(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return moduleFor(task).renderUserAnswer(userAnswer, task);
}
